import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { File as FileI } from '@ionic-native/file/ngx';
import { HandlerService } from './handler.service';
import { Platform } from '@angular/cdk/platform';
import { ApiService } from './api.service';
let blob, pdfData;

@Injectable({
  providedIn: 'root'
})
export class PdfService {
  email;
  loader: boolean = false; popup: boolean = false;
  constructor(private socialSharing: SocialSharing, private file: FileI, public handler: HandlerService,
    private platform: Platform, public service: ApiService) { }

    async generatePdf(data) {
      pdfData = data
      this.loader = true;
      var doc = new jsPDF()
      let date1: any;
      let date2: any;
      let date3: any;
      let date4: any;
      let bstartDate:any;
      let bendDate:any;
      if (this.platform.IOS) {
        if(data.invoiceDate)
        var a = data.invoiceDate.split('T')[0].split('-');
        if(data.dueDate)
        var b = data.dueDate.split('T')[0].split('-');
        if(data.billPeriodStartDate)
        var c = data.billPeriodStartDate.split('T')[0].split('-');
        if(data.billPeriodEndDate)
        var d = data.billPeriodEndDate.split('T')[0].split('-');
        if(a)
        date1 = new Date(a[0], a[1], a[2], 0, 0, 0)
        if(b)
        date2= new Date(b[0], b[1], b[2], 0, 0, 0)
        if(c)
        date3= new Date(c[0], c[1], c[2], 0, 0, 0)
        if(d)
        date4= new Date(d[0], d[1], d[2], 0, 0, 0)
      }
      else {
        date1 = new Date(data.invoiceDate);
        date2 = new Date(data.dueDate);
        date3 = new Date(data.billPeriodStartDate);
        date4 = new Date(data.billPeriodEndDate);
      }
        var y=180;
      if(data.type==2)
        var y = 170;
        if(data.type==4)
        var y = 175;
        let inDate;
        let duDate;
        if(date1)
      inDate =this.changeDate(date1);
      if(date2)
      duDate =this.changeDate(date2);
      if(date3)
      bstartDate =this.changeDate(date3);
      if(date4)
      bendDate =this.changeDate(date4);
      doc.setFontSize(20);
      doc.setFontType("bold");
      doc.setTextColor(79, 129, 199);
      doc.text(70, 25, data.header)
      doc.setFontSize(15);
      doc.setTextColor(0, 0, 0);
      doc.setFontType("bold");
      if(data.type!=4)
      doc.text(85, 35, data.subheader + ' ' + data.invoiceNbr)
      else
      doc.text(35, 35, data.subheader + ' ' + data.invoiceNbr)
      doc.setFontSize(15);
      doc.text(35, 45, 'DATE:' + inDate)
      if (data.header != "QUOTATION") {
        doc.text(35, 55, 'DUE DATE:' + duDate)
      }
      if(data.type!=4)
      doc.text(35, 70, data.biller.name)
      else
      doc.text(35, 60, data.biller.name)
      if(data.type!=4)
      doc.text(35, 125, 'To:' + data.payer.name)
      else
      doc.text(35, 115, 'To:' + data.payer.name)
      if (!data.status){
        if(data.type!=4)
        doc.text(35, 170, 'SERVICE')
        else    
        doc.text(35, 165, 'SERVICE')
      }
      if (data.header == "QUOTATION") {
        doc.text(130, 165, 'QTY');
        doc.text(160, 165, 'PRICE');
      }
      if (data.type==1) {
        doc.text(130, 170, 'PRICE');
      }
      data.serviceRequests.map((res: any) => {
        doc.setFontSize(15);
        doc.setFontType("normal")
        let x = res.providerService.name.length;
        if (!data.status) {
          if (x > 25) {
            var splitTitle = doc.splitTextToSize(res.providerService.name, 80);
            doc.text(35, y, splitTitle);
          }
          else {
            doc.text(35, y, res.providerService.name);
          }
        }
        if (data.header == "QUOTATION") {
          doc.text(135, y, res.askCount + '');
          doc.text(160, y, res.cost + '');
        }
        if (data.type==1) {
          doc.text(135, y, res.cost + '');
        }
        if (x >= 25) {
          y = y + 20;
        }
        else {
          y = y + 10;
        }
      })
      doc.setFontType("bold")
      if(data)
      if (data.header == "QUOTATION" || data.type!=2)
      doc.text(35, y, 'TAX:')
      if (data.header == "QUOTATION")
        doc.text(160, y, data.taxAmt + '')
      if (data.type==1)
      doc.text(135, y, data.taxAmt + '')
      if(data.type!=2)
      y = y + 10;
      if (data.header == "QUOTATION" || data.type!=2)
      doc.text(35, y, 'TOTAL:')
      if (data.header == "QUOTATION")
        doc.text(160, y, data.payTotal + '')
      if (data.type==1)
     doc.text(135, y, data.payTotal + '')
      doc.setFontSize(15);
      doc.setFontType("normal");
      if(data.type!=4){
      doc.text(35, 80, 'PHONE:' + data.biller.contactNbrMob);
      if(data.biller.address){
      let y;
      let z;
      if(data.biller.address.houseNbr)
      y=data.biller.address.houseNbr
      y=y+','+data.biller.address.houseNbr
      if(y)
      doc.text(35, 90,y);
      z=data.biller.address.cityId
      z=z+','+data.biller.address.stateId;
      if(z)
      doc.text(35, 100,data.biller.address.cityId+','+data.biller.address.stateId);
      }
      }
      else{
      doc.text(35, 70, 'PHONE:' + data.biller.contactNbrMob);
      let y;
      let z;
      if(data.biller.address){
       y=data.biller.address.houseNbr
      y=y+','+data.biller.address.street
      if(y)
      doc.text(35, 80,y);
      z=data.biller.address.cityId
      z=z+','+data.biller.address.stateId;
      if(z)
      doc.text(35, 90,z);
      }
      }
      if(data.type!=4)
      doc.text(35, 110, 'ABN/ACN: ' + data.biller.abn_acn);
      else
      doc.text(35, 100, 'ABN/ACN: ' + data.biller.abn_acn);
     if(data.type!=4){
      doc.text(35, 135, 'PHONE:' + data.payer.contactNbrMob);
      let y;
      let z;
      if(data.payer.address){
       y=data.payer.address.houseNbr
      if(y)
      y=y+','+data.payer.address.street
      doc.text(35, 145,y);
      z=data.payer.address.cityId;
      z=z+','+data.payer.address.stateId;
      if(z)
      doc.text(35, 155, z);
      }
     }
      else{
      doc.text(35, 125, 'PHONE:' + data.payer.contactNbrMob);
      let y;
      let z;
      if(data.payer.address){
       y=data.payer.address.houseNbr
      y=y+','+data.payer.address.street
      if(y)
      doc.text(35, 135, y);
      z=data.payer.address.cityId;
      z=z+','+data.payer.address.stateId;
      doc.text(35, 145,z);
      }
      }
      if (data.status) {
        doc.setFontSize(15);
        doc.setFontType("normal");
        doc.text(35, 165, 'Payment Status:' + data.status)
      }
      doc.setFontSize(15);
      doc.setFontType("bold");
      if(data.type==2){
        y=y+15;
        doc.setFontSize(15);
        doc.setFontType("bold");
        doc.text(35, y,'Billing Period:'+bstartDate+'-'+bendDate);
        y=y+15;
        doc.setFontSize(15);
        doc.setFontType("normal");
        doc.text(35, y,'Total Bill Amount:'+'$'+data.billAmountStr);
        y=y+15;
        doc.text(35, y,'Total Contractor Collected:'+'$'+data.payerCollectAmtStr);
        y=y+15;
        doc.text(35, y,'Total Org Collected:'+'$'+data.billerCollectAmtStr);
        y=y+15;
        doc.text(35, y,'Total Commission:'+'$'+data.commissionStr);
        y=y+15;
        doc.text(35, y,'Total Payable to Org:'+'$'+data.payTotalStr);
        y=y+15;
        let x='Total Payable to'+' '+data.biller.name+' '+'Org:'+'$'+data.payTotalStr
        let z = x.length;
        doc.setFontType("bold");
        if(z<50)
        doc.text(50, y,x);
        else{
        var splitTitle = doc.splitTextToSize(x, 150);
        doc.text(35, y, splitTitle);
        }
      }
      if (data.notes) {
        y = y + 15;
        doc.text(35, y, 'Notes:')
        y = y + 10;
        doc.setFontSize(15);
        doc.setFontType("normal");
        let z = data.notes.length;
        if(z<50)
        doc.text(35, y, data.notes)
        else{
          var splitTitle = doc.splitTextToSize(data.notes, 150);
          doc.text(35, y, splitTitle);
        }
      }
      blob = doc.output('blob', { type: 'application/pdf' });
  
      if (this.platform.ANDROID || this.platform.IOS) {
        this.mobShare(data, blob)
      }
      else {
        this.desktopShare(data)
      }
    }
    desktopShare(data) {
      let name = pdfData.header + '-' + pdfData.id + '.pdf';
      this.service.sendPdfToEmail(data.payer.emailId, blob, name).subscribe(res => {
        this.loader = false;
        this.handler.res("Shared Successfully")
      },
        err => {
          this.loader = false;
        })
    }
  
    mobShare(data, blob) {
      this.file.writeFile(this.file.cacheDirectory, data.header + data.id + '.pdf', blob, { replace: true }).then(res => {
        this.loader = false;
        var url = res.nativeURL;
        var msg = "hello";
        this.socialSharing.share(msg + data.header + data.id + '.pdf' + ' |', null, url, null)
          .then(() => { return null; })
          .catch(() => { return null })
      })
        .catch(err => {})
    }
  
    changeDate(date){
      let z = date.getFullYear();
      let month = date.getMonth() + 1;
      var fmon;
      month < 10 ? fmon = '0' + month : fmon = month;
      let day = date.getDate();
      var fday;
      day < 10 ? fday = '0' + day : fday = day;
      return fday + '-' + fmon + '-' + z;
    }
}
